import "../scss/index_hrn.scss";
import installPolyfills from "./install-polyfills";

installPolyfills()
  .then(() => import("./index"))
  .then(({ default: renderMain }) => {
    return renderMain();
  });
